export enum REGEX_TYPES {
  NAME = 'NAME',
  ID = 'ID',
  PHONE = 'PHONE',
  FULL_PHONE = 'FULL_PHONE',
  EMAIL = 'EMAIL',
}
